function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Capa_2",
  "data-name": "Capa 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Capa_1-2",
  "data-name": "Capa 1"
}, /*#__PURE__*/React.createElement("g", {
  id: "thoCvw"
}, /*#__PURE__*/React.createElement("path", {
  d: "M14.27,0V3.66H3.59v11H0V0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.88,14.68H57.32v-11H46.61V0H60.88Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M60.88,62.61H46.65V59H57.28v-11h3.6Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.23,40.36V36.71H42.94V33l0,0H46.5v3.64h7.1V55H35.81V47.72H32.23V44h3.52V40.35H32.23ZM50,40.4H39.41V51.33H50Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.83,40.36V36.7h3.53V33H7.3V29.39H25.08V33l0,0H18V44h3.51v3.66H18v3.63h7.08V47.73h3.57v3.61h3.55V55H14.42V51.35H10.81l0,0V47.69h3.52V40.35H10.83Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.65,11v3.66H25.1v11H7.3V7.37H25.06V11h3.61ZM10.85,22H21.48V11H10.85Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.94,29.36V25.7H35.83V7.37H53.58V25.65H46.49v3.69H42.92ZM50,11H39.39V22H50Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0,48H3.55v11H14.23v3.66H0Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M42.94,33H28.65l0,0v-7.3h3.54v3.63H42.94l0,0V33Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.65,14.68h3.53V22H28.66V14.68Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M46.49,29.36h7.1V33h-7.1V29.36Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.08,36.68V44H21.53V36.7H25.1Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.83,47.69H7.3V40.36h3.51V47.7Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.67,11V7.38h3.52V11H28.65Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.65,33v3.67H25.08l0,0V33l0,0h3.59Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M32.23,44H28.7V40.36h3.52V44Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.81,51.35V55H7.29V51.37h3.54Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43,44.05h3.49v3.6H43Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.94,14.73V18.3H14.43V14.73Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M43,18.3V14.71h3.49V18.3Z"
}))));
function SvgIconQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60.88 62.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconQr);
export default __webpack_public_path__ + "static/media/icon-qr.d85d68886f7645dfa999f7c2b6354cf7.svg";
export { ForwardRef as ReactComponent };